import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation createQrCodeMutation($input: CreateQrCodeInput!) {
    createQrCode(input: $input) {
      qrCodeEdge {
        node {
          ...QrCodeCell_qrCode
        }
      }
      lists {
        ...QrCodeList_lists
      }
    }
  }
`;

const createQrCode = (environment, listsId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: {},
    },
    configs: [
      {
        type: 'RANGE_ADD',
        parentID: listsId,
        edgeName: 'qrCodeEdge',
        connectionInfo: [
          {
            key: 'QrCodeList_qrCodes',
            rangeBehavior: 'append',
          },
        ],
      },
    ],
    ...args,
  });
};

export default createQrCode;
